import React from 'react'
import {
  Grid,  Typography, TextField, InputAdornment, Divider, Link, FormControlLabel, Checkbox } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Check } from '@mui/icons-material'

import { loadStripe } from '@stripe/stripe-js'
import { Elements } from '@stripe/react-stripe-js'
import PaymentForm from '../PaymentForm'

import { Link as RouterLink } from 'react-router'

const PricingSection = ({
  createToken,
  setResetToken,
  agree,
  setAgree,
  tokenLoading }) => {
  return (
    <>
      <Grid>
        <Grid container>
          <Grid
            style={{
              marginBottom: 10}}
          >
            <Typography
              variant="h5"
              style={{
                fontWeight: 600}}
            >
              Billing Info
            </Typography>
          </Grid>
          <Grid size={12}>
            <Elements
              stripe={loadStripe(
                import.meta.env.VITE_STRIPE_PUBLIC_KEY,
              )}
            >
              <PaymentForm
                createToken={createToken}
                setResetToken={setResetToken}
                tokenLoading={tokenLoading}
              />
            </Elements>
          </Grid>
        </Grid>
      </Grid>
      <Grid size={12}>
        <FormControlLabel
          control={
            <Checkbox
              checked={agree}
              required
              onChange={() => setAgree(!agree)}
            />
          }
          label={
            <Typography>
              I agree to the{' '}
              <Link
                component={RouterLink}
                to="/Terms"
                underline="hover"
                style={{
                  color: '#04a3e3'}}
                target="_blank"
              >
                Terms of Service
              </Link>{' '}
              and{' '}
              <Link
                component={RouterLink}
                to="/Privacy"
                underline="hover"
                style={{
                  color: '#04a3e3'}}
                target="_blank"
              >
                Privacy Policy
              </Link>
            </Typography>
          }
        />
      </Grid>
    </>
  )
}

export default PricingSection
